// Same rule as useCampaignQuery: 4xx responses (403 for non-internal users,
// 404 for unknown records) are never retried, so the permission/not-found
// state shows right away; only 5xx get a single retry.
export const retryOnServerError = (count, error) => (error?.response?.status ?? 0) >= 500 && count < 1;
